export const Theme = {
  fonts: {
    primary: "'Quattrocento Sans', sans",
    secondary: "'Raleway'"
  },
  colors: {
    black: '#161616',
    pages: {
      about: '#FFFFFF',
      alnylam: '#0099cc',
      rgg: '#000000',
      grubhub: '#F33746',
      levelUp: '#FDA02D',
      amalgam: '#9ad899',
      launch: '#F25EA2',
      photography: '#000000',
      contact: '#161616'
    }
  },
  spacing: {
    sideNav: {
      collapsed: '60px',
      expanded: '200px'
    }
  }
};
